import { VideoControl } from './libs/videoControl';

document.addEventListener('DOMContentLoaded', function () {
  const aweVideoContro = new VideoControl('js-awe-video');
  const otVideoContro = new VideoControl('js-ot-video');
});
